import React from 'react'

import { GraphBarType, GraphLineType, GraphPieType } from '@src/Application/Types/ComponentTypes'

import { BarGraph } from './BarGraph'
import { TitleSection } from './Graph.styled'
import { LineGraph } from './LineGraph'
import { PieGraph } from './PieGraph'

type Type = 'line' | 'pie' | 'bar'

type Props = (GraphLineType | GraphBarType | GraphPieType) & {
    graphType: Type
}

export const Graph = (props: Props): JSX.Element => {
    const { title, subtitle, mode } = props
    const { graphType, ...rest } = props

    return (
        <TitleSection title={title} subtitle={subtitle} mode={mode}>
            {graphType === 'line' && <LineGraph {...(rest as GraphLineType)} />}
            {graphType === 'bar' && <BarGraph {...(rest as GraphBarType)} />}
            {graphType === 'pie' && <PieGraph {...(rest as GraphPieType)} />}
        </TitleSection>
    )
}
